export default __webpack_public_path__ + "static/media/s4b-logo-single.c78a71f1.png";